
export default function SolutionsSection() {
  return (
    <section id="solutions" className="py-16 sm:py-20 bg-white scroll-mt-16 sm:scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
            ソリューション
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto px-4 text-left sm:text-center">
            ソーシャルパスのテクノロジーは、個人や企業のアイデンティティやオリジナルコンテンツを保護し、さまざまな情報流通課題をシンプルに解決へと導きます。
          </p>
        </div>

        <div className="space-y-12 sm:space-y-20 max-w-6xl mx-auto">
          {/* すべては情報の真正性に帰着する */}
          <div className="flex flex-col md:flex-row items-start md:space-x-8 space-y-4 sm:space-y-6 md:space-y-0">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto md:mx-0">
              <i className="ri-verified-badge-line text-white text-2xl sm:text-3xl"></i>
            </div>
            <div className="flex-1 text-left px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
                すべては情報の真正性に帰着する
              </h3>
              <div className="text-gray-600 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base md:text-lg max-w-4xl space-y-4 sm:space-y-6">
                <p>
                  日々の生活のなかで、多くの人がネット上で発信される情報を参考にし、少なからず判断や行動の拠り所としています。どの情報を信頼すべきかは、情報の発信者である人や組織、企業などへの信頼が重要な要素となります。
                </p>
                <p>
                  フェイクニュースやフィッシング詐欺などは、そうした信頼の象徴である本人の肖像や企業のロゴ、名称やアカウントなどを「本人になりすます」ことによって、信頼へのバイアスを巧みに利用し、悪意を持って扇動する行為といえます。
                </p>
                <p>
                  こうした行為から人々や社会を守るためには、「信頼できる発信元から」「偽装されていない本人によって発信された」「改ざんのない情報」といった「情報の真正性」が担保されることが求められます。だれもが情報の真正性を検証できる情報流通が実現し浸透することが、人を欺く情報から身を守れる社会へとつながります。
                </p>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-2xl p-4 sm:p-8 max-w-4xl">
                <img 
                  src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/9fd512577cf2f457ff432eee1d366531.png"
                  alt="情報の真正性を検証する仕組み"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-2xl p-4 sm:p-8 max-w-4xl mt-4 sm:mt-6">
                <img 
                  src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/009837820f2cd9df8b63e018ef6d41dd.png"
                  alt="情報の真正性の構成要素"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* 求められる情報発信者の行動と対応 */}
          <div className="flex flex-col md:flex-row items-start md:space-x-8 space-y-4 sm:space-y-6 md:space-y-0">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto md:mx-0">
              <i className="ri-user-voice-line text-white text-2xl sm:text-3xl"></i>
            </div>
            <div className="flex-1 text-left px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 text-center sm:text-left">
                求められる情報発信者の<br className="sm:hidden" />行動と対応
              </h3>
              <div className="text-gray-600 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base md:text-lg max-w-4xl space-y-4 sm:space-y-6">
                <p>
                  目覚ましい進化を遂げる生成AIは、誰もが容易にディープフェイクを生成することを可能にしました。ディープフェイクを悪用した「なりすまし行為」の横行は、情報の受け手を陥れるばかりでなく、なりすまされた当事者の信頼を毀損し、評判や社会的評価に関わるリスクにさらされることを意味します。
                </p>
                <p>
                  こうした問題を先端のAI技術で見破り対処する試みが活発化しています。一方で、双方の進化プロセスはイタチごっこの関係にあり根本的な解決への障害となっています。一度発信された情報の真正性を判別することは容易ではなく、情報発信者自らが「ことの起こり」である情報発信時に対処することが合理的であると考えられます。
                </p>
                <p>
                  情報発信者が自ら「情報の真正性を検証可能な仕組み」を通して情報発信することで、なりすまし行為などによる社会的リスクから身を守り、閲覧者が惑わされることなく真正な情報を得られることにつながります。情報発信者の行動と対応が、自らを守るばかりでなく信頼できる情報流通への光明をもたらします。
                </p>
              </div>
            </div>
          </div>

          {/* 情報の真正性を検証可能にする「環境固有性NFT©」 */}
          <div className="flex flex-col md:flex-row items-start md:space-x-8 space-y-4 sm:space-y-6 md:space-y-0">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto md:mx-0">
              <i className="ri-fingerprint-line text-white text-2xl sm:text-3xl"></i>
            </div>
            <div className="flex-1 text-left px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 text-center sm:text-left">
                情報の真正性を検証可能にする「環境固有性NFT©」
              </h3>
              <div className="text-gray-600 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base md:text-lg max-w-4xl space-y-4 sm:space-y-6">
                <p>
                  私たちは、情報の真正性を担保する「信頼できる発信元から」「偽装されていない本人によって発信された」「改ざんのない情報」という3つの要件を検証可能な仕組みを実現するために、「環境固有性NFT©」という新たな概念に基づく技術の開発(特許出願中)を行いました。
                </p>
                <p>
                  一般的なNFTが、デジタルコンテンツの唯一性と匿名の保有者を認証するのに対して、環境固有性NFTは、「個人や法人など特定の情報発信者に紐付いた特定の情報発信ロケーションという固有の環境」においてのみ「デジタルコンテンツの唯一性と特定の保有者を認証する」発明です。
                </p>
                <p>
                  情報の真正性を検証可能にすることを目的として発明された「環境固有性NFT」は、ソーシャルネットワークやWebなどを通した情報発信において発信者の権利やオリジナリティ、アイデンティティを守るばかりでなく、閲覧者に情報アクセスへの安心と信頼をもたらします。私たちは、合目的的で革新的な技術開発を通して、誰もがシンプルに活用可能な「情報の発信者と閲覧者を守る仕組み」を提供します。
                </p>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-2xl p-4 sm:p-8 max-w-4xl">
                <img 
                  src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/3062518ed50157ca1e8355fc7b4cb2ba.png"
                  alt="環境固有性NFTの概念図"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="bg-gradient-to-br from-purple-50 to purple-100/50 rounded-2xl p-4 sm:p-8 max-w-4xl mt-4 sm:mt-8">
                <img 
                  src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/21a64bf1e32c62bade7b46d27e5da2ee.png"
                  alt="情報の真正性を検証する仕組み"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* 堅固に権利を守り柔軟にユースケースを広げる「ロバストネスNFT©」 */}
          <div className="flex flex-col md:flex-row items-start md:space-x-8 space-y-4 sm:space-y-6 md:space-y-0">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto md:mx-0">
              <i className="ri-shield-star-line text-white text-2xl sm:text-3xl"></i>
            </div>
            <div className="flex-1 text-left px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 text-center sm:text-left">
                堅固に権利を守り柔軟に<br className="sm:hidden" />ユースケースを広げる<br className="sm:hidden" />「ロバストネスNFT©」
              </h3>
              <div className="text-gray-600 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base md:text-lg max-w-4xl space-y-4 sm:space-y-6">
                <p>
                  「環境固有性NFT」として登録された画像や文章、動画や音声などは、情報の真正性を検証可能なデジタルコンテンツとして機能することが求められます。ソーシャルネットワークなどへ情報発信する場合、例えば投稿写真がリサイズされたりクロップされるケースがあります。
                </p>
                <p>
                  こうした場合、NFTの唯一性の性質から投稿写真を検証しても権利外として認識されてしまい、情報の真正性検証の観点からも不都合です。この問題を解決するために、「デジタルコンテンツを一定の類似性の範囲において一括して権利化」するテクノロジー(特許出願中)、「ロバストネスNFT©」を開発しました。
                </p>
                <p>
                  ロバストネスNFTの発明によって、環境固有性NFTによる情報の真正性検証が実際の利用環境において有効に機能するばかりでなく、オリジナルコンテンツの権利を堅固に守る性質を活用することで、NFTの可能性を広げ、様々なユースケースやビジネスモデルへの適用が期待されます。
                </p>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-2xl p-4 sm:p-8 max-w-4xl">
                <img 
                  src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/f3548a4bb9e468c3f277379223484587.png"
                  alt="ロバストネスNFTの仕組み"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* 期待されるユースケース */}
          <div className="flex flex-col md:flex-row items-start md:space-x-8 space-y-4 sm:space-y-6 md:space-y-0">
            <div className="w-16 h-16 sm:w-20 sm:h-16 bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto md:mx-0">
              <i className="ri-lightbulb-line text-white text-2xl sm:text-3xl"></i>
            </div>
            <div className="flex-1 text-left px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 text-center sm:text-left">
                期待されるユースケース
              </h3>
              <div className="text-gray-600 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base md:text-lg max-w-4xl space-y-4 sm:space-y-6">
                <p>
                  ソーシャルパスのテクノロジーは、個人や企業のアイデンティティやオリジナルコンテンツを保護し、さまざまな情報流通課題をシンプルに解決へと導きます。
                </p>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-2xl p-4 sm:p-8 max-w-4xl">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <div className="bg-white rounded-xl p-5 sm:p-6 shadow-sm border border-purple-100 hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-purple-700 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-user-forbid-line text-white text-xl"></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base lg:text-lg">
                          <span className="sm:hidden">情報発信の<br />なりすましや<br />フェイクニュース対策</span>
                          <span className="hidden sm:inline">情報発信のなりすましや<br />フェイクニュース対策</span>
                        </h4>
                        <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">SNSやメディアでの本人確認と情報の真正性を検証し、なりすましやフェイクニュースを防止</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl p-5 sm:p-6 shadow-sm border border-purple-100 hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-purple-700 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-line text-white text-xl"></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base lg:text-lg">
                          <span className="sm:hidden">企業やメディアへの<br />なりすましサイト対策</span>
                          <span className="hidden sm:inline">企業やメディアへの<br />なりすましサイト対策</span>
                        </h4>
                        <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">公式サイトの真正性を証明し、偽サイトによる被害から企業ブランドと顧客を保護</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl p-5 sm:p-6 shadow-sm border border-purple-100 hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-purple-700 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-shopping-bag-line text-white text-xl"></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base lg:text-lg">
                          <span className="sm:hidden">ECサイトの<br />なりすましや<br />商品コンテンツ<br />情報保護対策</span>
                          <span className="hidden sm:inline">ECサイトのなりすましや<br />商品コンテンツ情報保護対策</span>
                        </h4>
                        <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">商品情報の著作権を保護し、偽ECサイトや不正コピーから事業者と消費者を守る</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl p-5 sm:p-6 shadow-sm border border-purple-100 hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-purple-700 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-shield-cross-line text-white text-xl"></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base lg:text-lg">
                          <span className="sm:hidden">フィッシングや<br />SNS詐欺広告対策</span>
                          <span className="hidden sm:inline">フィッシングや<br />SNS詐欺広告対策</span>
                        </h4>
                        <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">正規の情報発信元を検証可能にし、フィッシング詐欺や悪質な広告から利用者を保護</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-6 sm:mt-8 text-center">
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                    その他、私たちのテクノロジーの活用領域は、さまざまな可能性を秘めています
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
